
/* eslint-disable no-param-reassign */
import { ListType, ListState } from "@/lib/models";
import PlaylistEditIcon from "icons/PlaylistEdit.vue";
import DeleteIcon from "icons/Delete.vue";
import Vue from "vue";

interface Methods {
  enter: (el: Element) => void;
  leave: (el: Element) => void;
  afterEnter: (el: Element) => void;
  afterLeave: (el: Element) => void;
  nextFrame: (fn: any) => void;
  onFolderIconClick: () => void;
  onEditIconClick: () => void;
  onDeleteIconClick: () => void;
  onCancelClick: () => void;
}

interface Data {
  themeWatcher: MutationObserver | null;
}

interface Computed {
  iconColor: string;
}

interface Props {
  title: string;
  isEditing: boolean;
  showFolderIcon: boolean;
  updateListState: (value: ListState) => void;
  updateListType: (type: ListType) => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    PlaylistEditIcon,
    DeleteIcon,
  },
  data() {
    return {
      themeWatcher: null as MutationObserver | null, // テーマ変更検知用
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    showFolderIcon: {
      type: Boolean,
      default: true,
    },
    updateListState: Function,
    updateListType: Function,
  },
  methods: {
    enter(el) {
      if (el instanceof HTMLElement) {
        el.style.overflow = "hidden";
        el.style.width = "0";

        this.nextFrame(() => {
          el.style.width = `${el.scrollWidth}px`;
        });
      }
    },
    leave(el) {
      if (el instanceof HTMLElement) {
        el.style.overflow = "hidden";
        el.style.width = `${el.scrollWidth}px`;

        this.nextFrame(() => {
          el.style.width = "0";
        });
      }
    },
    afterEnter(el) {
      if (el instanceof HTMLElement) {
        el.style.width = "";
        el.style.overflow = "";
      }
    },
    afterLeave(el) {
      if (el instanceof HTMLElement) {
        el.style.width = "";
        el.style.overflow = "";
      }
    },
    nextFrame(fn) {
      // NOTE: 以下参考にした
      // https://note.com/noliaki/n/n6e3a60748c11
      window.requestAnimationFrame(() => window.requestAnimationFrame(fn));
    },
    onFolderIconClick() {
      const { updateListType } = this;
      if (!updateListType) return;
      updateListType(ListType.FOLDER);
    },
    onEditIconClick() {
      const { updateListState } = this;
      if (!updateListState) return;
      updateListState(ListState.EDIT);
    },
    onDeleteIconClick() {
      const { updateListState } = this;
      if (!updateListState) return;
      updateListState(ListState.DELETE);
    },
    onCancelClick() {
      const { updateListState } = this;
      updateListState(ListState.COMPLETE);
    },
  },
  created() {
    // テーマ変更を検知するMutationObserverを設定
    if (typeof window !== "undefined") {
      this.themeWatcher = new MutationObserver(() => {
        // テーマ変更時にcomputed propertyを再計算させるため、$forceUpdateを呼び出す
        this.$forceUpdate();
      });
      this.themeWatcher.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["data-app-theme"],
      });
    }
  },
  beforeDestroy() {
    // MutationObserverをクリーンアップ
    if (this.themeWatcher) {
      this.themeWatcher.disconnect();
      this.themeWatcher = null;
    }
  },
  computed: {
    iconColor() {
      // CSS変数からアイコン色を取得
      if (typeof window !== "undefined") {
        const computedStyle = getComputedStyle(document.documentElement);
        return computedStyle.getPropertyValue("--color-icon-primary").trim() || "#404040";
      }
      return "#404040";
    },
  },
});
